import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ManufacturingPage from './pages/ManufacturingPage';
import ThirdPartyManufacturing from './pages/ThirdPartyManufacturing';
import QualityPage from './pages/QualityPage';
import ContactPage from './pages/ContactPage';
import StartYourBrandPage from './pages/StartYourBrandPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminEnquiries from './pages/AdminEnquiries';
import './App.css';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path='/' element={
            <>
              <Navbar />
              <HomePage />
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path='/about' element={<><Navbar /><AboutPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/products' element={<><Navbar /><ProductsPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/products/:id' element={<><Navbar /><ProductDetailPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/manufacturing' element={<><Navbar /><ManufacturingPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/third-party-manufacturing' element={<><Navbar /><ThirdPartyManufacturing /><Footer /><WhatsAppButton /></>} />
          <Route path='/quality' element={<><Navbar /><QualityPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/contact' element={<><Navbar /><ContactPage /><Footer /><WhatsAppButton /></>} />
          <Route path='/start-your-brand' element={<><Navbar /><StartYourBrandPage /><Footer /><WhatsAppButton /></>} />
          
          {/* Admin Routes */}
          <Route path='/admin' element={<AdminLogin />} />
          <Route path='/admin/dashboard' element={<AdminDashboard />} />
          <Route path='/admin/products' element={<AdminProducts />} />
          <Route path='/admin/enquiries' element={<AdminEnquiries />} />
        </Routes>
        <Toaster position='top-right' richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
